import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

/** Moduli */
import { CoreSharedUiModule } from '@kodit/core/shared-ui';

/** PrimeNg */
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MenuModule } from 'primeng/menu';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { SelectButtonModule } from 'primeng/selectbutton';

/** Components */
import { AdresaFormComponent } from './adresa/adresa-form/adresa-form.component';
import { DrzavaDropdownComponent } from './adresa/ui/drzava-dropdown/drzava-dropdown.component';
import { RacunTableComponent } from './racun/racun-table/racun-table.component';
import { TipMagacinaFormComponent } from './tip-magacina/tip-magacina-form/tip-magacina-form.component';
import { LagerTableComponent } from './lager/lager-table/lager-table.component';
import { LagerTransakcijeTableComponent } from './lager/lager-transakcije-table/lager-transakcije-table.component';
import { TableFilterFormComponent } from './table/table-filter-form/table-filter-form.component';
import { UplataTableComponent } from './izvod/uplata-table/uplata-table.component';
import { ObradaTransakcijeIzvodaComponent } from './izvod/obrada-transakcije-izvoda-form/obrada-transakcije-izvoda-form.component';
import { NeplaceniRacunTableComponent } from './racun/neplaceni-racun-table/neplaceni-racun-table.component';
import { IsplataTableComponent } from './izvod/isplata-table/isplata-table.component';
import { LagerTransakcijeFormComponent } from './lager/lager-transakcije-form/lager-transakcije-form.component';
import { ObradaPocetnogStanjaComponent } from './izvod/obrada-pocetnog-stanja/obrada-pocetnog-stanja.component';
import { PosaljiElektronskiFormComponent } from './racun/posalji-elektronski-form/posalji-elektronski-form.component';
import { LagerFilterComponent } from './lager/lager-filter/lager-filter.component';
import { CancelIzlazniRacunFormComponent } from './racun/cancel-izlazni-racun-form/cancel-izlazni-racun-form.component';
import { StornoIzlazniRacunFormComponent } from './racun/storno-izlazni-racun-form/storno-izlazni-racun-form.component';
import { PosaljiNaSefFormComponent } from './racun/posalji-na-sef-form/posalji-na-sef-form.component';
import { PocetnoStanjeRacunTableComponent } from './izvod/pocetno-stanje-racun-table/pocetno-stanje-racun-table.component';
import { UplateIsplateFilterComponent } from './izvod/uplate-isplate-filter/uplate-isplate-filter.component';
import { RacunSummaryComponent } from './summary/racun-summary/racun-summary.component';
import { RacunVanValuteSummaryComponent } from './summary/racun-van-valute-summary/racun-van-valute-summary.component';
import { LagerTransakcijeFilterComponent } from './lager/lager-transakcije-filter/lager-transakcije-filter.component';
import { KompenzacijaTableComponent } from './racun/kompenzacija-table/kompenzacija-table.component';
import { RacunUploadFormComponent } from './racun/racun-upload-form/racun-upload-form';
import { RacunFilterOpsegDropdownComponent } from './racun/racun-filter/filter-components/racun-filter-opseg-dropdown/racun-filter-opseg-dropdown.component';
import { RacunFilterPeriodDropdownComponent } from './racun/racun-filter/filter-components/racun-filter-period-dropdown/racun-filter-period-dropdown.component';
import { RacunFilterComponent } from './racun/racun-filter/racun-filter.component';
import { PeriodMesecDropdownComponent } from './racun/racun-filter/filter-components/period-mesec-dropdown/period-mesec-dropdown.component';
import { RacunExportFormComponent } from './racun/racun-export-form/racun-export-form.component';
import { DuplirajRacuneFormComponent } from './racun/dupliraj-racune-form/dupliraj-racune-form.component';
import { PosaljiPredracuneEmailomFormComponent } from './racun/posalji-predracune-emailom-form/posalji-predracune-emailom-form.component';
import { PosaljiIzjavuZaOdbitakPdvFormComponent } from './racun/posalji-izjavu-za-odbitak-pdv-form/posalji-izjavu-za-odbitak-pdv-form/posalji-izjavu-za-odbitak-pdv-form.component';
import { CheckboxModule } from 'primeng/checkbox';
import { SliderModule } from 'primeng/slider';
import { EvidentiranjePredracunaOptionDialogComponent } from './izvod/obrada-transakcije-izvoda-form/evidentiranje-predracuna-option-dialog/evidentiranje-predracuna-option-dialog.component';
import { UplatnicaFormComponent } from './racun/uplatnica-form/uplatnica-form.component';
import { KlasifikacijaDokumentaFormComponent } from './racun/klasifikacija-dokumenta-form/klasifikacija-dokumenta-form.component';
import { UnosTransakcijeFormComponent } from './izvod/unos-transakcije-form/unos-transakcije-form.component';
import { PackageAdditionComponent } from './registracija/odabir-paketa/package-addition/package-addition.component';
import { OdabirPaketaForm2Component } from './registracija/odabir-paketa-form2/odabir-paketa-form2.component';
import { PackageBoxComponent } from "./registracija/odabir-paketa/package-box/package-box.component";
import { InputSwitchModule  } from 'primeng/inputswitch';
import { MagacinLagerDropdownComponent } from './lager/magacin-lager-dropdown/magacin-lager-dropdown.component';
import { IzlazniRacunPageComponent } from './racun/izlazni-racun-page/izlazni-racun-page.component';
import { RacunSaldoComponent } from './racun/racun-saldo/racun-saldo.component';
import { CoreSharedModule } from '@kodit/core/shared';
import { SaldoCardComponent } from './racun/racun-saldo/saldo-card/saldo-card.component';
import { SaldoCardSkeletonComponent } from './racun/racun-saldo/saldo-card-skeleton/saldo-card-skeleton.component';
import { UlazniRacunPageComponent } from './racun/ulazni-racun-page/ulazni-racun-page.component';
import {
  OdobravanjeOdbacivanjeRacunaFormComponent
} from './racun/neobradjeni-racuni/odobravanje-odbacivanje-racuna-form/odobravanje-odbacivanje-racuna-form.component';
import {
  SinhronizacijaFormComponent
} from './racun/neobradjeni-racuni/neobradjen-sef-racun-table/sinhronizacija-form/sinhronizacija-form.component';
import {
  OdobravanjeOznakeFormComponent
} from './racun/neobradjeni-racuni/odobravanje-odbacivanje-racuna-form/odobravanje-oznake-form/odobravanje-oznake-form.component';
import {
  CreateOdobrenRacunFormComponent
} from './racun/neobradjeni-racuni/create-odobren-racun-form/create-odobren-racun-form.component';
import {
  RazlogStorniranjaOdbijanjaDialogComponent
} from './racun/neobradjeni-racuni/razlog-storniranja-odbijanja-dialog/razlog-storniranja-odbijanja-dialog.component';
import {
  NeobradjenRacunFilesFormComponent
} from './racun/neobradjeni-racuni/neobradjen-racun-files-form/neobradjen-racun-files-form';
import {
  NeobradjeniSefRacuniFilterComponent
} from './racun/neobradjeni-racuni/neobradjeni-sef-racuni-filter/neobradjeni-sef-racuni-filter.component';
import {
  NeobradjenSefRacunTableComponent
} from './racun/neobradjeni-racuni/neobradjen-sef-racun-table/neobradjen-sef-racun-table.component';
import { JoyrideModule } from "ngx-joyride";
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { PdfNativePrintDirective } from './pdf/pdf-native-print.directive';
import { UsloviUgovoraDialogComponent } from './registracija/odabir-paketa-form2/uslovi-ugovora-dialog/uslovi-ugovora-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CoreSharedUiModule,
    InputTextModule,
    DropdownModule,
    CalendarModule,
    InputNumberModule,
    RadioButtonModule,
    MenuModule,
    MessagesModule,
    MessageModule,
    SelectButtonModule,
    CheckboxModule,
    SliderModule,
    InputSwitchModule,
    CoreSharedModule,
    JoyrideModule,
    PdfJsViewerModule
  ],
  declarations: [
    AdresaFormComponent,
    DrzavaDropdownComponent,
    RacunTableComponent,
    TipMagacinaFormComponent,
    LagerTableComponent,
    LagerTransakcijeTableComponent,
    RacunFilterComponent,
    TableFilterFormComponent,
    UplataTableComponent,
    ObradaTransakcijeIzvodaComponent,
    NeplaceniRacunTableComponent,
    IsplataTableComponent,
    LagerTransakcijeFormComponent,
    ObradaPocetnogStanjaComponent,
    PosaljiElektronskiFormComponent,
    LagerFilterComponent,
    CancelIzlazniRacunFormComponent,
    StornoIzlazniRacunFormComponent,
    PosaljiNaSefFormComponent,
    PocetnoStanjeRacunTableComponent,
    UplateIsplateFilterComponent,
    RacunSummaryComponent,
    RacunVanValuteSummaryComponent,
    RacunUploadFormComponent,
    LagerTransakcijeFilterComponent,
    KompenzacijaTableComponent,
    RacunFilterOpsegDropdownComponent,
    RacunFilterPeriodDropdownComponent,
    PeriodMesecDropdownComponent,
    RacunExportFormComponent,
    DuplirajRacuneFormComponent,
    PosaljiPredracuneEmailomFormComponent,
    PosaljiIzjavuZaOdbitakPdvFormComponent,
    EvidentiranjePredracunaOptionDialogComponent,
    UplatnicaFormComponent,
    KlasifikacijaDokumentaFormComponent,
    UnosTransakcijeFormComponent,
    PackageAdditionComponent,
    PackageBoxComponent,
    OdabirPaketaForm2Component,
    IzlazniRacunPageComponent,
    RacunSaldoComponent,
    SaldoCardComponent,
    SaldoCardSkeletonComponent,
    UlazniRacunPageComponent,
    SinhronizacijaFormComponent,
    OdobravanjeOznakeFormComponent,
    CreateOdobrenRacunFormComponent,
    RazlogStorniranjaOdbijanjaDialogComponent,
    NeobradjenRacunFilesFormComponent,
    NeobradjeniSefRacuniFilterComponent,
    OdobravanjeOdbacivanjeRacunaFormComponent,
    NeobradjenSefRacunTableComponent,
    MagacinLagerDropdownComponent,
    UsloviUgovoraDialogComponent,
    PdfNativePrintDirective,
  ],
  exports: [
    AdresaFormComponent,
    RacunTableComponent,
    TipMagacinaFormComponent,
    LagerTableComponent,
    LagerTransakcijeTableComponent,
    TableFilterFormComponent,
    UplataTableComponent,
    ObradaTransakcijeIzvodaComponent,
    NeplaceniRacunTableComponent,
    IsplataTableComponent,
    RacunSummaryComponent,
    DrzavaDropdownComponent,
    RacunVanValuteSummaryComponent,
    KompenzacijaTableComponent,
    PeriodMesecDropdownComponent,
    PackageAdditionComponent,
    PackageBoxComponent,
    OdabirPaketaForm2Component,
    IzlazniRacunPageComponent,
    RacunSaldoComponent,
    SaldoCardComponent,
    SaldoCardSkeletonComponent,
    UlazniRacunPageComponent,
    SinhronizacijaFormComponent,
    OdobravanjeOznakeFormComponent,
    CreateOdobrenRacunFormComponent,
    RazlogStorniranjaOdbijanjaDialogComponent,
    NeobradjenRacunFilesFormComponent,
    NeobradjeniSefRacuniFilterComponent,
    OdobravanjeOdbacivanjeRacunaFormComponent,
    NeobradjenSefRacunTableComponent,
    PdfNativePrintDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CoreSharedSubformsModule {}
